'use client';

import { cn } from '@/utils/cn';

const ContactMap = ({
  googleMapsIframe,
  title,
  className,
}: ContactMapProps) => {
  const iframeHtml = /title=/i.test(googleMapsIframe)
    ? googleMapsIframe
    : googleMapsIframe.replace(/<iframe/i, `<iframe title="${title}"`);

  return (
    <div
      className={cn(
        className,
        'w-full [&_iframe]:w-full [&_iframe]:h-[300px] rounded-xs overflow-hidden',
      )}
      dangerouslySetInnerHTML={{ __html: iframeHtml }}
      suppressHydrationWarning
    />
  );
};

export default ContactMap;

type ContactMapProps = {
  googleMapsIframe: string;
  title: string;
  className?: string;
};
